export default __webpack_public_path__ + "static/media/news-mobile-sc.3930c284.jpg";